import { isEmpty, isNil } from 'ramda';

import EngagementTimeSheet from 'src/types/resources/EngagementTimeSheet';
import { formatCurrency } from 'src/utils/formatCurrency';

const EngagementTimeSheetPresenter = {
  talentPayRate: (engagementTimeSheet: EngagementTimeSheet) => {
    const { talentPayRate } = engagementTimeSheet;
    return !isNil(talentPayRate) ? `${formatCurrency(parseFloat(talentPayRate))}/hr` : '-';
  },
  isEmptyPO: (engagementTimeSheet: EngagementTimeSheet): boolean => {
    return isEmpty(engagementTimeSheet.po);
  },
  isSinglePO: (engagementTimeSheet: EngagementTimeSheet): boolean => {
    return engagementTimeSheet.po.length === 1;
  },
  isMultiplePO: (engagementTimeSheet: EngagementTimeSheet): boolean => {
    return engagementTimeSheet.po.length > 1;
  },
};

export default EngagementTimeSheetPresenter;
